module.exports = __webpack_public_path__ + "static/media/icon_add_spot.2ff4ac05.svg";